<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="17">
                <el-form ref="form" :model="form" label-width="85px" class="flxz">
                    <el-col :span="22">
                        <el-form-item label="法律名称：">
                        <template>
                            <el-select size="small" v-model="name" filterable clearable remote reserve-keyword placeholder="请输入法律名称"
                            :remote-method="remoteMethod" :loading="loading" :style="{width:'77%'}" @change="get_tiao">
                            <el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                        </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="法律条款：">
                          <el-row>
                          <el-col :span="5">
                              <el-form-item label="">
                              <!-- <span>第</span> -->
                                  <el-select size="small" v-model="tiao" placeholder="请选择" :style="{width:'95%'}" @change="get_kuan">
                                  <el-option v-for="item in tiao_list" :key="item.dict_value" :label="item.tiao" :value="item.dict_value">
                                  </el-option>
                                  </el-select>
                              <!-- <span>条</span> -->
                              </el-form-item>
                          </el-col>
                          <el-col :span="5" v-if="kuan_show==true">
                              <el-form-item label="">
                              <!-- <span>第</span> -->
                                  <el-select size="small" v-model="kuan" placeholder="请选择"  :style="{width:'95%'}" @change="get_kuan_item">
                                  <el-option v-for="item in kuan_list" :key="item.kuan" :label="item.kuan" :value="item.content">
                                  </el-option>
                                  </el-select>
                              <!-- <span>款</span> -->
                              </el-form-item>
                          </el-col>
                          <el-col :span="5" v-if="xiang_show==true">
                              <el-form-item label="">
                              <!-- <span>第</span> -->
                                  <el-select size="small" v-model="xiang" placeholder="请选择" :style="{width:'95%'}" style="margin-right:20px;" @change="get_xiang_item">
                                  <el-option v-for="item in xiang_list" :key="item.xiang" :label="item.xiang" :value="item.content">
                                  </el-option>
                                  </el-select>
                              <!-- <span>项</span> -->
                              </el-form-item>
                          </el-col>
                          <el-col :span="2" style="margin-left:10px;">
                              <el-button type="primary" size="medium" @click="add">添加</el-button>
                          </el-col>
                          </el-row>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="23">
                        <el-form-item label="法律内容：">
                            <el-input type="textarea" :rows="4" placeholder="" v-model="flnr" disabled=""></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="20" v-if="isAdd">
                    <el-form-item label-width="0">
                        <el-input type="textarea" :rows="4" placeholder="" v-model="content1"  disabled=""></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="3" v-if="isAdd" style="margin-left:10px;">
                        <el-button type="primary" size="medium" @click="confirm">确定引入</el-button>
                    </el-col> -->
                    <el-col :span="23">
                    <el-form-item label-width="0">
                        <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="form.content" :style="{width:'100%'}" @input="renew($event)"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0">
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="danger" @click="cancel">取消</el-button>
                        <el-button style="float:right;" type="warning" @click="getCase">案例参考</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                  <div v-show="isActive == index" class="zfmb2">
                    <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getFalvnr(itema,i)">{{itema.mcjianxie}}</span>
                  </div>
                </li>
              </ul>
          
            </el-col>
        </el-row>
        <el-dialog title="案例参考" :visible.sync="open" top="8vh" width="1100px" append-to-body :close-on-click-modal="false">
            <el-form :model="queryParams" ref="queryForm" :inline="true">
                <el-form-item label="关键词:" prop="gjc">
                    <el-input
                    v-model="queryParams.gjc"
                    placeholder="请输入"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item label="案由:" prop="anyou">
                    <el-input
                    v-model="queryParams.anyou"
                    placeholder="请输入"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item label="专业类型:" prop="zylb">
                    <el-select v-model="queryParams.zylb" placeholder="请选择专业类别" size="small">
                        <el-option
                            v-for="dict in zylbOptions"
                            :key="dict.ID"
                            :label="dict.mc"
                            :value="dict.ID"
                            ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="处罚类别:" prop="cflb">
                    <el-select v-model="queryParams.cflb" placeholder="请选择" size="small">
                        <el-option
                            v-for="dict in zylbOptions"
                            :key="dict.ID"
                            :label="dict.mc"
                            :value="dict.ID"
                            ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批状态:" prop="spzt">
                    <el-select v-model="queryParams.spzt" placeholder="请选择" size="small" style="width:120px;">
                        <el-option
                            v-for="dict in ztOptions"
                            :key="dict.id"
                            :label="dict.city"
                            :value="dict.city"
                            ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建人:" prop="cjr">
                    <el-select v-model="queryParams.cjr" placeholder="请选择" size="small" style="width:120px;">
                        <el-option
                        v-for="(dict,index) in userOptions"
                                :key="index"
                            :label="dict.xm"
                            :value="dict.xm"
                            ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="立案日期:" >
                    <el-date-picker size="small" clearable
                        v-model="queryParams.sj"
                        type="date"
                        placeholder="选择日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    至
                    <el-date-picker size="small" clearable
                        v-model="queryParams.sj2"
                        type="date"
                        placeholder="选择日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="ajckList">
                <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="单位名称" prop="dwmc" />
                <el-table-column label="案由" prop="anyou" />
                <el-table-column label="来源" prop="laiyuan"  />
                <el-table-column label="处罚文号" prop="isjiance" width="100" />
                <el-table-column label="创建人" align="center" prop="cjr" width="90" />
                <el-table-column label="立案日期" align="center" prop="bl_date" width="110"  />

                <el-table-column label="" align="center" class-name="small-padding fixed-width" width="50" >
                    <template slot-scope="scope">
                      <el-button
                    size="small"
                    type="text"
                    @click="handleShow(scope.row)"
                >查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-part" style="padding:20px 20px 50px;">
                <el-pagination v-if="pageshow"
                    background
                    @size-change='handleSizeChange'
                    @current-change='handleCurrentChange'
                    :current-page="queryParams.page"
                    :page-sizes="[10,20,30,40]"
                    :page-size="queryParams.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="total" style=" float:right;">
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['leixing','text'],
      data() {
        return {
          form:{
            content:'',
          },
          current:0,
          activeMoban: 'first',
          Mobancontroll:true,
          MbOptions:[],
          Is_moban:true,
          loadingModal:false,
          loading:false,
          name:'',
          list: [],
          options: [],
          chapter:'',
          flnr:'',
          chapter_list:[],
          tiao:'',
          tiao_content:'',
          tiao_list:[],
          kuan:'',
          kuan_list:[],
          kuan_show:true,
          xiang:'',
          xiang_id:'',
          xiang_list:[],
          xiang_show:true,
          fl_info:{}, //法律信息
          tiao_info:{}, //条信息
          kuan_info:{}, //款信息
          xiang_info:{}, //项信息
          content1:'',
          total: 0,
          value:'',
          mbGroup:[],
          // text:'',
          JgdxpcmbList: [],
          queryParams: {
            mc: null,
            mcjianxie: null,
            isComm: 1,
            zylb: null,
            leixing: null,
            px: null,
            pageSize: 100,
            orderByColumn: 'id',
            isAsc: 'desc'     //desc
         },
         arr:['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'],
         zylbOptions: [],
         jdyOptions:[],
         // 表单参数
         form: {
          content:''
         },
         // 表单校验
         rules: {
           mcjianxie: [
             { required: true, message: "名称不能为空", trigger: "blur" }
           ],
           mc: [
             { required: true, message: "模板内容不能为空", trigger: "blur" }
           ],
           // zylb: [
           //   { required: true, message: "专业类别不能为空", trigger: "change" }
           // ],
         },
         isShowTooltip: false,
         loading2:false,

         isActive:'-1',
         isActive2:'-1',
         zfmbList:[],

         open:false,
         ajckList:[],
         pageshow:true,
         ztOptions:[],
         userOptions:[],
         baseUrl:''
        }
      },
      watch:{
        leixing(){
          this.form.content = ''
          this.isActive2 = '-1'
          this.getList();
        }
      },
      created() {
        
      },
      mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getFalv`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {}
        })
        .then(response => {
            this.list =  response.data.data || []
            if(!this.name){
              this.options =  response.data.data || []
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        this.getList();
      },
      methods: {
        getList(){
          let t = this.leixing == 1 ? '违法法律' : '处罚依据'
          axios({
                method: 'post',
                url: this.baseUrl+`/login/getZfmb`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    leibie:t,
                    find:''
                }
            })
            .then(response => {
                console.log(response.data);
                this.zfmbList = response.data.data || []
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        onMouseOver (str) { // 内容超出，显示文字提示内容
          const tag = this.$refs[str]
          const parentWidth = 255 // 获取元素父级可视宽度
          const contentWidth = tag.offsetWidth // 获取元素可视宽度
          this.isShowTooltip = contentWidth <= parentWidth
        },
        // 表单重置
        reset() {
          this.form = {
            id: null,
            mc: null,
            mcjianxie: null,
            mcjianxie2: null,
            zylb: null,
            // leixing: null,
            keydate: null,
            ismore: null,
            px: null,
            num: null,
            czydm: null,
            creattime: null,
            happendate: null,
            isdelete: null,
            cMid: null,
            bz: null,
            deldm: null,
            deltime: null,
            editdm: null
          };
          this.resetForm("form");
        },
        renew(e){
          this.$forceUpdate()
        },
        remoteMethod: function (query) {
          console.log(query,this,this.list)
          if (query !== '') {
            this.options = this.list.filter(function (item) {
              return item.name.indexOf(query) > -1;
            });
          } else {
             this.options = this.list;
          }
        },
        get_tiao(name){
          if(name){
            console.log(name,this.options)
            this.fl_info = this.options.find((item)=>{
                return item.name === name;
            });
            console.log(this.fl_info)
            this.tiao=''
            this.kuan=''
            this.xiang=''
          let nm = this.fl_info.name.replace("《", "")
          nm = nm.replace("》", "")
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getFalvTiaoNum`,
                data:{
                  falvName:nm,
                  type:tiao
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                  this.tiao_list = res.data.data || [];
                  this.tiao_list.map(item=>{
                    item.tiao = item.dict_label;
                  })
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            }) 
          }else{
            this.options = this.list;
          }
        },
        async get_kuan(){
          this.kuan_show = false
          this.xiang_show = false
          console.log(this.tiao)
          this.tiao_info = this.tiao_list.find((item)=>{
               return item.dict_value === this.tiao;
          });
          console.log(this.tiao_info,this.name)
          let nm = this.name.replace("《", "")
          nm = nm.replace("》", "")
          axios({
                method: 'post',
                url: this.baseUrl+`/login/getFalvTiaoNum`,
                data:{
                  falvName:nm,
                  type:neirong,
                  tiao:this.tiao
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                  if(res.data.data){
                    this.kuan=''
                    this.xiang=''
                    this.kuan_info={}
                    this.xiang_info={}
                    this.xiang_id = res.data.data[0].id
                    this.tiao_content=res.data.data[0].content
                    if (this.tiao_content.indexOf('||') != -1) {
                      this.kuan_show=true
                      this.xiang_show=false
                      this.kuan_content = this.tiao_content.replace(/\n/g, '').split('||')
                      let datas=[]
                      this.kuan_content.map((item,index)=>{
                        datas.push({
                          kuan:'第'+ this.arr[index] +'款',
                          content:item,
                          index:index+1
                        })
                      })
                      this.kuan_list=datas
                      console.log(this.kuan_show)
                    }else{
                      this.kuan_show=false
                      this.xiang_show=false
                      axios({
                          method: 'post',
                          url: this.baseUrl+`/login/getFalvKuan`,
                          data:{
                            falvId:this.xiang_id,
                            kuan:''
                          },
                          headers: { 
                              "Content-Type": "application/json"
                          },
                      }).then(res => {
                          if(res.data.code == 0 && res.data.data){
                              this.xiang_list = res.data.data || [];
                              if(this.xiang_list.length != 0){
                                this.xiang_list.map(item=>{
                                  if(item.lawItem != '99'){
                                    item.lawItem_dictText=item.lawItem_dictText.match(/（(\S*)）/)[1]
                                    item.xiang = '第'+ item.lawItem_dictText +'项'
                                    item.content = item.content
                                    item.id =  item.id
                                    item.lawClause = item.lawClause
                                    item.lawItem =  item.lawItem
                                  }
                                })
                                this.xiang_show=true
                              }else{
                                this.xiang_show=false
                              }
                          }else{
                              if(res.data.msg){
                                  this.$message.error(res.data.msg)
                              }
                          }
                      }).catch(error => {
                          this.$message.error(error);
                      })   
                      
                    }
                  }
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            }) 
        },
        get_kuan_item(){
          console.log(this.kuan,this.kuan_list)
          this.kuan_info = this.kuan_list.find((item)=>{
               return item.content === this.kuan;
          });
          axios({
              method: 'post',
              url: this.baseUrl+`/login/getFalvKuan`,
              data:{
                falvId:this.xiang_id,
                kuan:this.kuan_info.index
              },
              headers: { 
                  "Content-Type": "application/json"
              },
          }).then(res => {
              if(res.data.code == 0 && res.data.data){
                  this.xiang=''
                  this.xiang_info={}
                  this.xiang_list = res.data.data || [];
                  if(this.xiang_list != ''&&this.xiang_list != 0){
                    this.xiang_list.map(item=>{
                      if(item.lawItem != '99'){
                        item.lawItem_dictText=item.lawItem_dictText.match(/（(\S*)）/)[1]
                        item.xiang = '第'+ item.lawItem_dictText +'项'
                      }
                    })
                    this.xiang_show=true
                  }else{
                    this.xiang_show=false
                  }
              }else{
                  if(res.data.msg){
                      this.$message.error(res.data.msg)
                  }
              }
          }).catch(error => {
              this.$message.error(error);
          }) 
        },
        get_xiang_item(){
          this.xiang_info = this.xiang_list.find((item)=>{
               return item.content === this.xiang;
          });
        },
        add(){
          if(this.fl_info.name==undefined||this.tiao_info.dict_label==undefined){
            this.$message.error('请选择法律条款')
            return;
          }
          if(this.kuan_show==true&&this.xiang_show==false){
            // if( this.kuan_info.kuan!=undefined){
            //   this.content1='《'+ this.fl_info.name +'》'+ this.tiao_info.dict_label + this.kuan_info.kuan
            //   this.flnr=this.kuan_info.content
            // }else{
            //   this.content1='《'+ this.fl_info.name +'》'+ this.tiao_info.dict_label
            //   this.flnr=this.tiao_content
            // }
            if( this.kuan!=''){
              this.content1=this.fl_info.name+ this.tiao_info.dict_label + this.kuan_info.kuan
              this.flnr = this.kuan_info.content
            }else this.$message.error('请选择款')
          }else{
            if(this.xiang_show==true && this.xiang_info.xiang!=undefined){
              // this.content1='《'+ this.fl_info.name +'》'+ this.tiao_info.dict_label + this.xiang_info.xiang
              // this.flnr=this.tiao_content+ this.xiang_info.lawItem_dictText + this.xiang_info.content
              if(this.xiang!='') {
                if(this.kuan_info.content){
                  this.content1 = this.fl_info.name + this.tiao_info.dict_label + this.kuan_info.kuan + this.xiang_info.xiang
                  this.flnr = this.kuan_info.content + this.xiang_info.xiang.substr(1,this.xiang_info.xiang.length-2) + this.xiang_info.content
                }else{
                  this.content1 = this.fl_info.name + this.tiao_info.dict_label + this.xiang_info.xiang
                  this.flnr = this.tiao_content + this.xiang_info.xiang.substr(1,this.xiang_info.xiang.length-2) + this.xiang_info.content
                }
              }else this.$message.error('请选择项')
            }else{

              let content=''
              if(this.kuan_info.content){
                this.content1=this.fl_info.name+ this.tiao_info.dict_label+this.kuan_info.kuan
                content += this.kuan_info.content
              }else{
                this.content1=this.fl_info.name+ this.tiao_info.dict_label
                content += this.tiao_content
              }
              this.xiang_list.map(item=>{
                content+= item.lawItem_dictText+item.content
              })
              this.flnr = content
            }
          }
          this.Is_moban=false
          this.confirm()
        },
        singleMb(index,item){
          this.current=index
          this.content1 = item.mc
        },
        confirm(){
          if(this.content1!='' && this.content1!=null){
            if(this.form.content==null){
              this.form.content=''
            }
            if(this.form.content.indexOf(this.content1) >= 0){
              this.$message.error('不能重复添加')
              return;
            }
            // if(this.code=='03'||this.code=='04'){
              //if(this.Is_moban==false && this.form.content!=''){
              if(this.form.content!=''){
                this.form.content += '、' + this.content1
              }else{
                this.form.content += this.content1
                // this.Is_moban=true
              }
            // }else{
            //   this.form.content += this.content1
            // }
            this.$forceUpdate()
          }else{
             this.$message.error('请选择模板内容')
          }
        },
        submit(){
          // if(this.form.content!=''&&this.form.content!=null&&(this.code=='03'||this.code=='04')){
          //   this.form.content=this.form.content.replace(/;/g, '；')
          //   let law=this.form.content.split('；')
          //   law= law.sort();
          //   for(var i = 0; i < law.length - 1; i++) {
          //     if(law[i] == law[i + 1]) {
          //       this.$message.error('法律条款重复')
          //       return
          //     }
          //   }
          // }
          this.$emit("handleBack",this.form.content,this.leixing)
        },
        cancel(){
          this.$emit("falvTk",false)
        },

        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getFalvnr(itema,i){
          this.isActive2 = i
          if(this.form.content.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            this.form.content = this.form.content ? this.form.content + '、' + itema.mc : itema.mc
          }
        },

        getCase(){
          this.open = true
        },
        handleShow(row){
          console.log(row)
        },

        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
      }
    }
</script>

<style>
.zfmb{ border:1px solid #DCDFE6; padding: 20px;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}

</style>

<style scoped>
.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
</style>